export default "__VITE_ASSET__Bb8wgarB__"